import curry from 'ramda/src/curry'
import pipe from 'ramda/src/pipe'
import path from 'ramda/src/path'

import dropEventSelector from 'root/src/client/logic/dropEvent/selectors/dropEventSelector'

export default curry((propName, state) => pipe(
	dropEventSelector, path(Array.isArray(propName) ? propName : [propName]),
)(state))
